import {
	getPaymentBox,
	getComponentNameFromPaymentBox,
	setHostedOverride
} from './woocommerce';

export const getComponentNameByGatewayId = ( gatewayId ) => {
	const gatewayIdToComponentName = {
		'payoneer-checkout': 'cards',
		'payoneer-afterpay': 'afterpay',
	};

	return gatewayIdToComponentName[ gatewayId ];
}

const { paymentFieldsComponentAttribute } = window.PayoneerData;

export const mountComponents = ( components, sdk ) => {
	for ( const [ componentName, component ] of Object.entries( components ) ) {
		const container = findComponentContainer( componentName );
		if (
			container instanceof Element &&
			sdk.isAvailable( componentName )
		) {
			component.mount( container );
		}
	}
};

export const findComponentContainer = function ( componentName ) {
	return document.querySelector(
		`[${paymentFieldsComponentAttribute}=${componentName}]`
	);
};
